<div class="step-con-box">
    <div class="step-subject-box">
        <div class="main-txt">
            {{ "join.done.title" | translate }}
        </div>
        <div class="sub-txt">
            {{ "join.done.guideLine" | translate }}
        </div>
    </div>
    <article class="sign-in-success">
        <div class="success-box">
            <b>
                {{ joinEmail! }}
            </b>
            {{ "join.done.welcomeLine1" | translate }}
            <br />
            {{ "join.done.welcomeLine2" | translate }}
        </div>
    </article>
    <article class="sign-in-btn">
        <div class="btn-box">
            <a class="primary-btn" (click)="next()">
                {{ "join.done.nextButton" | translate }}
            </a>
        </div>
    </article>
</div>